import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UpdateQuestionRequest } from "../../type";
import { HttpStatus } from "../../enums/httpStatus";
import { getAttributeDetail } from "./AttributeDetailSlice";
import { patch } from "../../util/APIService";

export interface UpdateQuestionSliceProp {
  attributeId: number;
  questionId: number;
  questionDetails: UpdateQuestionRequest
}

export const updateQuestion = createAsyncThunk(
  "admin/questions/update",
  async (params: UpdateQuestionSliceProp, storeActions) => {
    const url = `api/v1/admin/attributes/${params.attributeId}/questions/update/${params.questionId}`;
    const response: any = await patch(url, params.questionDetails, storeActions);

    if (response.status === HttpStatus.OK) {
      storeActions.dispatch(getAttributeDetail({ attributeId: params.attributeId }))
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        errorMessage: (await response.json()).message,
      };
    }
  }
);

const updateQuestionSlice = createSlice({
  name: "updateQuestion",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    errorMessage: null as string | null,
    data: null as number | null,
  },
  reducers: {
    clearUpdateQuestionData: (state) => {
      state.status = null;
      state.loading = false;
      state.errorMessage = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateQuestion.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.errorMessage = null;
      } else if (action.payload.errorMessage !== undefined) {
        state.data = null;
        state.errorMessage = action.payload.errorMessage;
      }
    });
    builder.addCase(updateQuestion.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.errorMessage = null;
    });
    builder.addCase(updateQuestion.rejected, (state) => {
      state.status = HttpStatus.SERVICE_UNAVAILABLE;
      state.loading = false;
      state.data = null;
      state.errorMessage = null;
    });
  },
});

export const { clearUpdateQuestionData } = updateQuestionSlice.actions;

export const selectUpdateQuestionResponseHttpStatus = (state) => state.updateQuestionData.status;
export const selectUpdateQuestionResponseLoading = (state) => state.updateQuestionData.loading;
export const selectUpdateQuestionResponseErrorMessage = (state) =>
  state.updateQuestionData.errorMessage;
export const selectUpdateQuestionResponseSuccessMessage = (state) =>
  state.updateQuestionData.data?.message;
export const selectUpdateQuestionResponseData = (state) => state.updateQuestionData.data;

export default updateQuestionSlice;
